import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Shield, LogOut } from "lucide-react";
import { motion } from "framer-motion";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 w-full z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-display text-xl tracking-wide uppercase text-white">
          Coleman<span className="text-kinetic">©</span>Customs
        </Link>
        <nav className="hidden md:flex items-center gap-8 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">
          <Link to="/shop" data-testid="nav-shop-link" className="hover:text-kinetic transition-colors">Shop</Link>
          <Link to="/shop?custom=1" data-testid="nav-custom-link" className="hover:text-kinetic transition-colors">Custom Studio</Link>
          <Link to="/track" data-testid="nav-track-link" className="hover:text-kinetic transition-colors">Track Order</Link>
          <Link to="/lookbook" data-testid="nav-lookbook-link" className="hover:text-kinetic transition-colors">Lookbook</Link>
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className="text-kinetic hover:text-white transition-colors flex items-center gap-1">
              <Shield size={12} /> Ops Console
            </Link>
          )}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <button
              data-testid="nav-account-button"
              onClick={() => navigate("/account")}
              className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-kinetic transition-colors"
            >
              <User size={16} />
              <span className="hidden sm:inline">{user.name?.split(" ")[0] || "Account"}</span>
            </button>
          ) : (
            <Link to="/auth" data-testid="nav-login-link" className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-kinetic transition-colors">
              <User size={16} /> <span className="hidden sm:inline">Login</span>
            </Link>
          )}
          {user && (
            <button data-testid="nav-logout-button" onClick={logout} title="Log out" className="text-zinc-500 hover:text-kinetic transition-colors">
              <LogOut size={16} />
            </button>
          )}
          <button
            data-testid="nav-cart-button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 bg-kinetic text-white font-mono text-xs uppercase tracking-widest px-4 py-2 hover:bg-orange-600 active:scale-95 transition-colors"
          >
            <ShoppingBag size={15} />
            <span className="hidden sm:inline">Cart</span>
            {count > 0 && (
              <span data-testid="nav-cart-count" className="absolute -top-2 -right-2 bg-volt text-black text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </motion.header>
  );
}
